import { create } from 'zustand';

const useUserStore = create((set) => ({
    user: {
        name: '',
        email: '',
        isLoggedIn: false,
        db: 'tdr',
        token: "",
        role: ""
    },
    setUser: (newData) =>
        set((state) => ({
            user: { ...state.user, ...newData },
        })),
    setName: (name) =>
        set((state) => ({
            user: { ...state.user, name },
        })),
    setDB: () =>
        set((state) => ({
            user: {
                ...state.user,
                db: state.user.db === "tdr" ? "pro" : "tdr",
            },
        })),
    setEmail: (email) =>
        set((state) => ({
            user: { ...state.user, email },
        })),
    login: () =>
        set((state) => ({
            user: { ...state.user, isLoggedIn: true },
        })),
    logout: () =>
        set((state) => ({
            user: { name: '', email: '', isLoggedIn: false },
        })),
}));

export default useUserStore;